// extracted by mini-css-extract-plugin
module.exports = {"section":"testimonial-module--section--HENgo","image":"testimonial-module--image--3RbBp"};